import { mapGetters } from 'vuex';
import * as moment from 'moment';

export const FormatDatesMixin = {
    computed: {
        ...mapGetters(['dateFormat']),

        localDateFormat() {
            return this.dateFormat
                .toUpperCase()
                .slice(0, this.dateFormat.length - 2);
        },

        localStartDate() {
            return moment(this.startDate).format(this.localDateFormat);
        },

        localEndDate() {
            return moment(this.endDate).format(this.localDateFormat);
        },
    }
};


// WEBPACK FOOTER //
// ./src/mixins/FormatDatesMixin.js